var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_89_219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 11.5267C0 3.0288 0 -1.22017 2.43694 -3.85998C4.87387 -6.4998 8.79562 -6.5 16.6401 -6.5H31.3601C39.2042 -6.5 43.1261 -6.5 45.5632 -3.85998C48 -1.22017 48 3.02859 48 11.5267V27.4735C48 35.9712 48 40.22 45.5631 42.8602C43.1261 45.5 39.2044 45.5 31.3599 45.5H16.6403C8.796 45.5 4.87387 45.5 2.43712 42.86C0.000375032 40.22 0 35.9714 0 27.4733V11.5267Z",
    fill: "#4945FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.12 9.27325H16.96V18.2H25.2V27.1265H33.4399V9.61999C33.4399 9.42844 33.2966 9.27325 33.12 9.27325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.8799 18.2H25.1999V18.5467H24.8799V18.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.9598 18.2H24.8798C25.0566 18.2 25.1999 18.3552 25.1999 18.5465V27.1265H17.2799C17.2379 27.1265 17.1962 27.1176 17.1574 27.1002C17.1186 27.0828 17.0833 27.0573 17.0536 27.0251C17.0239 26.9929 17.0003 26.9547 16.9842 26.9126C16.9681 26.8706 16.9598 26.8255 16.9598 26.78V18.2ZM25.1999 27.1265H33.4398L25.4729 35.7573C25.3722 35.8666 25.1999 35.7892 25.1999 35.635V27.1265ZM16.9598 18.2H9.10601C8.96351 18.2 8.89226 18.0131 8.99295 17.904L16.9598 9.27325V18.2Z",
    fill: "#9593FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflow);
export default __webpack_public_path__ + "static/media/webflow.e47477861a9ddf591b7aa415b2963140.svg";
export { ForwardRef as ReactComponent };